/**
 * Service for managing DJ Software preferences and integration
 */
import ApiService from './Api.service';
import {
  UpdateUserDjSoftwareDto,
  UserDjSoftwareEnum,
} from '@cratehackers/api-client';

// Types

export interface DJSoftwareInfo {
  id: UserDjSoftwareEnum;
  name: string;
  icon?: any; // For Ionicon references
  description?: string;
}

class DJSoftwareService {
  /**
   * Save user's selected DJ software preferences
   */
  async saveSelectedSoftware(selectedIds: UserDjSoftwareEnum[]): Promise<void> {
    localStorage.setItem('selectedDJSoftware', JSON.stringify(selectedIds));
    const chAPIClient = ApiService.getApiClient();
    const dto: UpdateUserDjSoftwareDto = {
      djSoftware: selectedIds,
    };
    const updatedUser = await chAPIClient.usersControllerUpdateDjSoftware({
      updateUserDjSoftwareDto: dto,
    });
    console.log(updatedUser.djSoftware + ' added to user software');
  }

  /**
   * Get user's selected DJ software preferences
   */
  getSelectedSoftware(): UserDjSoftwareEnum[] {
    const saved = localStorage.getItem('selectedDJSoftware');
    if (!saved) return [];

    try {
      return JSON.parse(saved) as UserDjSoftwareEnum[];
    } catch (e) {
      console.error('Error parsing saved DJ software preferences', e);
      return [];
    }
  }

  /**
   * Check if a specific DJ software is selected
   */
  isSoftwareSelected(id: UserDjSoftwareEnum): boolean {
    return this.getSelectedSoftware().includes(id);
  }
}

// Export as a singleton
export const djSoftwareService = new DJSoftwareService();
export default djSoftwareService;
